import { MobileSettingsKeys, SettingsKeys } from './appSettingsKeys';
import { cleanNulls } from './utils';
const stylesParamFontKeyToAppSettingsMapper = {
  widgetTitleFont: SettingsKeys.MULTI_OFFERINGS_TITLE_FONT,
  filterTitleFont: SettingsKeys.CATEGORY_NAME_FONT,
  dropdownTextFont: MobileSettingsKeys.MOBILE_CATEGORY_NAME_FONT,
  serviceNameFont: SettingsKeys.OFFERING_NAME_FONT,
  serviceTagLineFont: SettingsKeys.OFFERING_TAGLINE_FONT,
  moreInfoButtonFont: SettingsKeys.OFFERING_MORE_INFO_LABEL_FONT,
  serviceDetailsFont: SettingsKeys.OFFERING_DETAILS_FONT,
  courseAvailabilityFont: SettingsKeys.COURSE_AVAILABILITY_FONT,
  bookButtonFont: SettingsKeys.BUTTON_TEXT_FONT,
  explorePlansFont: SettingsKeys.EXPLORE_PLANS_FONT
};
export function mergeAppSettingsNumbersToStyleParamsFonts(appSettings) {
  function mapFont(_ref) {
    let {
      appSettingsFont
    } = _ref;
    return appSettingsFont || null;
  }
  const newFonts = {};
  Object.keys(stylesParamFontKeyToAppSettingsMapper).forEach(styleParamsFontKey => {
    newFonts[styleParamsFontKey] = mapFont({
      appSettingsFont: appSettings[stylesParamFontKeyToAppSettingsMapper[styleParamsFontKey]]
    });
  });
  return cleanNulls(newFonts);
}
//# sourceMappingURL=mergeFonts.js.map